"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hook = void 0;
var Hook;
(function (Hook) {
    Hook["STOREFRONT"] = "Storefront";
    Hook["CATALOGUE"] = "Catalogue";
    Hook["CATALOGUE_ADD_TO_CART"] = "CatalogueAddToCart";
    Hook["COLLECTION_PRODUCT"] = "CollectionProduct";
    Hook["SEARCH_CATALOGUE"] = "SearchCatalogue";
    Hook["PRODUCT_DETAIL_BODY"] = "ProductDetailBody";
    Hook["PRODUCT_ADD_TO_CART"] = "ProductAddToCart";
    Hook["CART_ITEM_DETAIL"] = "CartItemDetail";
})(Hook = exports.Hook || (exports.Hook = {}));
